import type { ReactNode } from 'react';
import v3 from 'components/landing/v3/v3.module.css';
import styles from './SplitHeading.module.css';

/* Eyebrow and title on the left, intro copy and its link on the right, from lg up. */
export const SplitHeading = ({
  titleId,
  eyebrow,
  title,
  body,
  link,
}: {
  /** id of the title, for the section's aria-labelledby */
  titleId: string;
  eyebrow: ReactNode;
  title: ReactNode;
  body: ReactNode;
  link: ReactNode;
}) => (
  <div className={styles.heading}>
    <div className={styles.lead}>
      <p className={`${v3.eyebrow} ${styles.eyebrow}`} data-reveal>
        {eyebrow}
      </p>
      <h2
        id={titleId}
        className={`${v3.sectionTitle} ${styles.title}`}
        data-reveal
      >
        {title}
      </h2>
    </div>
    <div className={styles.aside} data-reveal>
      <p className={styles.body}>{body}</p>
      {link}
    </div>
  </div>
);
